import axios from "axios";
import moment from "moment";
var CryptoJS = require("crypto-js");

export async function motocaddyBackendPortalRequest(action, body, user) {
  const isPrivate = user ? true : false;


  const config = {
    host: "https://api-connect3.igolf.com/rest/action", // live environment for igolf
    apiKey: "9ah-QD0mQw88egc",
    secretKey: "eX-v3LlGAPEf08lK7Inb00LtT10-Ys",
    userType: "mcAdmin"
  };

      // if (process.env.NODE_ENV === "development") {
      //   // DB migration
      //   // config.host = "https://dev-api.igolf.com";// stage environment for igolf
      //   // config.apiKey= "sw68shrAhRazPLc";
      //   // config.secretKey= "DpW-HSZRNAtbWTAUxszqXcHnrN87gF";
      //   // original
      //   config.host = "https://dev-api.igolf.com/rest/action"; // stage environment for igolf
      //   config.apiKey = "Sneb5VLHM6fDNeQ";
      //   config.secretKey = "hfMsCEc6UbZRELPfClUMUqDyz_Je9o";
      //   config.userType = "mcAdmin";
      // }
  const apiParams = {
    action,
    apiKey: config.apiKey,
    username: user ? user.userName : undefined,
    apiVersion: '1.1',
    signatureVersion: "2.0",
    signatureMethod: "HmacSHA256",
    date: moment.utc().format('YYMMDDHHmmssZZ'),
    responseFormat: "JSON",
    userSecretKey: user ? user.userSecretKey : undefined,
  };

  let toSign ="";
  if(isPrivate){
    toSign = `${action}/${apiParams.apiKey}/${apiParams.username}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.date}/JSON`
  }else{
    toSign = `${action}/${apiParams.apiKey}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.date}/JSON`

  }

const key = config.secretKey + (user && user.secretKey ? user.secretKey : "");



apiParams.signature =  CryptoJS.HmacSHA256(toSign, key)
.toString(CryptoJS.enc.Base64)
.replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "");




    let signedPath = "";
if(isPrivate){
   signedPath = `${apiParams.apiKey}/${apiParams.username}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.signature}/${apiParams.date}/JSON` + (config.userType ? '?UserType=' + config.userType : '')
}else{
   signedPath = `${apiParams.apiKey}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.signature}/${apiParams.date}/JSON` + (config.userType ? '?UserType=' + config.userType : '')

}
  try {
    return await axios.post(
      `${config.host}/${action}/${signedPath}`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  } catch (e) {
    // console.log("Request Error:", e);
  }
}
